(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.constant:headerMenuLinks
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio')
    .value('headerMenuLinks', {
        '0': {
            'name': 'DEFAULT_USUARIS',
            'state': 'usuaris',
            'onclick': '',
            'permit': 'USUARISMENU'
        },
        '1':{
            'name': 'DEFAULT_ROLS',
            'state': 'rols',
            'onclick': '',
            'permit': 'ROLSMENU'
        },

        '2':{
            'name': 'DEFAULT_ENTITATS',
            'state': 'entitats',
            'onclick': '',
            'permit': 'ENTITATMENU'
        },

        '3':{
            'name': 'DEFAULT_PRODUCTES',
            'state': 'productes',
            'onclick': '',
            'permit': 'PRODUCTEMENU'
        }
    });
}());
